module.exports = __webpack_public_path__ + "static/media/6530.4a7787a9.jpg";